import React from "react";
import { Transfer, Layout } from "antd";
import I18n from "../../i18n";
import { OThemeText } from "../text/OText";
import { OButton } from "../button/index";
import { ArrayUtil } from "../../util";
import ContentBox from "../layout/ContentBox";
import Metrics from "../../theme/Metrics";
import { TransferStyle } from "../../theme/AntdStyle";
class AdminTransfer extends React.Component {
  state = {
  	selectedKeys: [],
  	targetKeys: [],

  	// Changed data
  	toUser:[],
  	toAdmin:[]
  }
  initTargetKeys = [];
  texts = {};
  constructor(props){
  	super(props);
  	const { members, admins, setRef = ref=>{}} = props;
  	// console.log('[AdminTransfer] constructor.props: ',props);
  	this.initTargetKeys = this.toTargetsIndex(members, admins);
  	this.state = { targetKeys: this.initTargetKeys };
  	this.texts = {
  		set_admin: I18n.t("set_admin"),
  		remove_admin: I18n.t("remove_admin"),
  		admin_limit_warning: I18n.t("admin_limit_warning"),
  	};
  	setRef(this);
  }
  componentWillReceiveProps(props){
  	// console.log('[AdminTransfer] cwrp.props: ',props);
  	const { members, admins } = props;
  	this.initTargetKeys = this.toTargetsIndex(members, admins);
  	this.setState({ targetKeys: this.initTargetKeys });
  }
  toTargetsIndex(members, admins){
  	const out = [];
  	const memberIDs = Array.from(members, v=>v.title);
  	for(let i=0;i<admins.length;i+=1){
  		const index = memberIDs.indexOf(admins[i].title);
  		if(index!==-1){
  			out.push(index);
  		}
  	}
  	return out;
  }
  filterOption = (inputValue, option) => {
  	return option.title.indexOf(inputValue) > -1;
  }
  handleChange(tranferTargetKeys, direction, moveKeys){
  	let { toUser = [], toAdmin = [] } = this.state;
  	switch(direction){
  	case "right":
  		ArrayUtil.concatUnique(toAdmin, moveKeys, (admins, key)=>{
  			return (admins.indexOf(key) === -1) && (this.initTargetKeys.indexOf(key) === -1);
  		});
  		toUser = toUser.filter(v=>moveKeys.indexOf(v) === -1);
  		break;
  	case "left":
  		ArrayUtil.concatUnique(toUser, moveKeys, (users, key)=>{
  			return this.initTargetKeys.indexOf(key) !== -1;
  		});
  		toAdmin = toAdmin.filter(v=>moveKeys.indexOf(v) === -1);
  		break;
  	}
  	this.setState({ targetKeys: tranferTargetKeys, toAdmin, toUser });
  }
  onSelectChanged(sourceSelectKeys, targetSelectKeys){
  	const max = this.props.maxAdmin;
  	const { targetKeys } = this.state;
  	const sourceLimit = max - targetKeys.length;
  	const targetLimit = max;
  	this.setState({
  		selectedKeys: sourceSelectKeys.splice(0,sourceLimit)
  			.concat(targetSelectKeys.splice(0, targetLimit)),
  	});
  }
  getTargetValues(){
  	const { members } = this.props;
  	const { toAdmin = [], toUser = [] } = this.state;
  	return {
  		toAdmin: members.filter((v,i)=>toAdmin.indexOf(v.key) !== -1),
  		toUser: members.filter((v,i)=>toUser.indexOf(v.key) !== -1)
  	};
  }
  render(){
  	const { members, maxAdmin, footer } = this.props;
  	const { selectedKeys, targetKeys, isMax } = this.state;
  	// console.log('[AdminTransfer] state: ',this.state);
  	return <div>
  		<div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
  			<style>{TransferStyle.fullWidth}</style>
  			<Transfer
  				style={{width:"100%"}}
  				dataSource={members}
  				showSearch={false}
  				// onSearchChange={(dir, event)=>{
  				//   console.log("onSearchChange: ",dir);
  				// }}
  				titles={[
  					this.texts.set_admin,
  					this.texts.remove_admin
  				]}
  				listStyle={{
  					width: "calc(50% - 23px)",
  					height: 300,
  				}}
  				filterOption={this.filterOption}
  				selectedKeys={selectedKeys}
  				targetKeys={targetKeys}
  				onChange={this.handleChange.bind(this)}
  				onSelectChange={this.onSelectChanged.bind(this)}
  				render={item=>item.title}
  			/>
  		</div>
  		<div style={{display:"inline-flex", width:"100%", justifyContent:"space-around"}}>
  			{footer}
  			<OThemeText style={{marginTop:Metrics.button.bigSpaceMargin}}>
  				{/*{this.texts.admin_limit_warning.replace('%s', maxAdmin)}*/}
  			</OThemeText>
  		</div>
  	</div>;
  }
}

const SessionTrans = (props) => {
	return (<Transfer
		dataSource={props.dataSource}
		showSearch
		titles={[I18n.t("set_admin"), I18n.t("remove_admin")]}
		listStyle={{
			width: 300,
			height: 300,
		}}
		filterOption={props.filterOption}
		targetKeys={props.targetKeys}
		onChange={props.onChange}
		onSelectChange={props.onSelectChange}
		render={props.render}
	/>);
};

AdminTransfer.defaultProps = {
	members:[],
	admins:[],
	maxAdmin: 3,
	setRef:ref=>{},
	footer:undefined,
};

export { AdminTransfer, SessionTrans };
export default SessionTrans;



// WEBPACK FOOTER //
// ./src/components/form/AdminTransfer.js